import React, { useState, useEffect } from "react";
import {
  collection,
  getDocs,
  addDoc,
  updateDoc,
  deleteDoc,
  doc,
} from "firebase/firestore";
import { db } from "../firebase/firebaseConfig";

const LeadTimeManager = () => {
  const [products, setProducts] = useState([]);
  const [newProduct, setNewProduct] = useState({
    description: "",
    minDays: "",
    maxDays: "",
  });

  const [editId, setEditId] = useState(null);
  const [editedProduct, setEditedProduct] = useState({});

  const leadTimesRef = collection(db, "leadtimes");

  useEffect(() => {
    const fetchData = async () => {
      const snapshot = await getDocs(leadTimesRef);
      const docs = snapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));
      setProducts(docs);
    };

    fetchData();
  }, []);

  const handleAdd = async () => {
    const { description, minDays, maxDays } = newProduct;
    if (!description || !minDays || !maxDays) return;

    const newDoc = {
      description,
      minDays: parseInt(minDays),
      maxDays: parseInt(maxDays),
    };

    const docRef = await addDoc(leadTimesRef, newDoc);
    setProducts((prev) => [...prev, { id: docRef.id, ...newDoc }]);
    setNewProduct({ description: "", minDays: "", maxDays: "" });
  };

  const handleDelete = async (id) => {
    await deleteDoc(doc(db, "leadtimes", id));
    setProducts((prev) => prev.filter((p) => p.id !== id));
  };

  const handleEdit = (product) => {
    setEditId(product.id);
    setEditedProduct(product);
  };

  const handleSave = async () => {
    const { id, description, minDays, maxDays } = editedProduct;
    await updateDoc(doc(db, "leadtimes", id), {
      description,
      minDays: parseInt(minDays),
      maxDays: parseInt(maxDays),
    });

    setProducts((prev) =>
      prev.map((p) => (p.id === id ? editedProduct : p))
    );
    setEditId(null);
    setEditedProduct({});
  };

  return (
    <div className="max-w-3xl mx-auto p-4 space-y-6">
      <h2 className="text-xl font-bold">Product Lead Times</h2>

      <table className="w-full border border-collapse">
        <thead>
          <tr className="bg-gray-200">
            <th className="border p-2">Description</th>
            <th className="border p-2">Min Days</th>
            <th className="border p-2">Max Days</th>
            <th className="border p-2">Actions</th>
          </tr>
        </thead>
        <tbody>
          {products.map((p) =>
            editId === p.id ? (
              <tr key={p.id} className="bg-yellow-100">
                <td className="border p-2">
                  <input
                    type="text"
                    value={editedProduct.description}
                    onChange={(e) =>
                      setEditedProduct({ ...editedProduct, description: e.target.value })
                    }
                    className="w-full"
                  />
                </td>
                <td className="border p-2">
                  <input
                    type="number"
                    value={editedProduct.minDays}
                    onChange={(e) =>
                      setEditedProduct({ ...editedProduct, minDays: e.target.value })
                    }
                    className="w-full"
                  />
                </td>
                <td className="border p-2">
                  <input
                    type="number"
                    value={editedProduct.maxDays}
                    onChange={(e) =>
                      setEditedProduct({ ...editedProduct, maxDays: e.target.value })
                    }
                    className="w-full"
                  />
                </td>
                <td className="border p-2">
                  <button
                    onClick={handleSave}
                    className="text-green-600 font-semibold mr-2"
                  >
                    Save
                  </button>
                  <button
                    onClick={() => setEditId(null)}
                    className="text-gray-500"
                  >
                    Cancel
                  </button>
                </td>
              </tr>
            ) : (
              <tr key={p.id}>
                <td className="border p-2">{p.description}</td>
                <td className="border p-2">{p.minDays}</td>
                <td className="border p-2">{p.maxDays}</td>
                <td className="border p-2">
                  <button
                    onClick={() => handleEdit(p)}
                    className="text-primary font-semibold mr-2"
                  >
                    Edit
                  </button>
                  <button
                    onClick={() => handleDelete(p.id)}
                    className="text-red-600 font-semibold"
                  >
                    X
                  </button>
                </td>
              </tr>
            )
          )}
        </tbody>
      </table>

      <div className="mt-6">
        <h3 className="font-semibold mb-2">Add New Product</h3>
        <div className="flex gap-2">
          <input
            type="text"
            placeholder="Description"
            value={newProduct.description}
            onChange={(e) =>
              setNewProduct({ ...newProduct, description: e.target.value })
            }
            className="border p-2 flex-1"
          />
          <input
            type="number"
            placeholder="Min Days"
            value={newProduct.minDays}
            onChange={(e) =>
              setNewProduct({ ...newProduct, minDays: e.target.value })
            }
            className="border p-2 w-24"
          />
          <input
            type="number"
            placeholder="Max Days"
            value={newProduct.maxDays}
            onChange={(e) =>
              setNewProduct({ ...newProduct, maxDays: e.target.value })
            }
            className="border p-2 w-24"
          />
          <button
            onClick={handleAdd}
            className="bg-primary text-white px-4 py-2 rounded hover:bg-hover"
          >
            Add
          </button>
        </div>
      </div>
    </div>
  );
};

export default LeadTimeManager;
